module.exports = __webpack_public_path__ + "img/perforaciones_4-3_1024.0d66c436.jpg";